import * as Yup from "yup";
import { Button, Col, FloatingLabel, Form, Row, Spinner } from "react-bootstrap";
import { useCallback, useState } from "react";
import { Formik } from "formik";
import { useMutation } from "react-query";

import LwcErrorBoundary from "../../../components/LwcErrorBoundary";
import PasswordWithShow from "../../../components/PasswordWithShow";

import { changeMyEmailMutation } from "../services/changeEmailMutation";
import registrationFormModel from "../../login/registration/registrationFormModel";
import { useAuth } from "../../../services/wp.auth.service";
import { useNotifications } from "../../../components/NotificationsContext";

const initialValues = {
	password: "",
	email: ""
};

const {
	formField: {
		email
	}
} = registrationFormModel;

const schema = Yup.object().shape({
	[email.name]: Yup.string().email(`${email.invalidErrorMsg}`).
		required(`${email.requiredErrorMsg}`),
	password: Yup.string().required("Please enter your current password.")
});

const ChangeEmailForm = () => {
	const { user } = useAuth();
	const {
		mutateAsync: changeUserEmail
	} = changeMyEmailMutation(useMutation);
	const { addNotification } = useNotifications();

	const [loading, setLoading] = useState(false);

	const handleFormSubmit = useCallback(async (variables) => {
		setLoading(true);
		try {
			const res = await changeUserEmail(variables);
			if (res.success) {
				addNotification({
					message: res.message,
					type: "success"
				});
			} else {
				addNotification({
					message: res.message,
					type: "danger"
				});
			}
		} catch (error) {
			addNotification({
				message: error.message,
				type: "danger"
			});
		}
		setLoading(false);
	}, []);

	return (
		<div className="mb-5">
			<LwcErrorBoundary>
				<h5>Change Email Address</h5>
				<p><strong>Current Email:</strong> {user.email}</p>
				<Formik
					initialValues={initialValues}
					onSubmit={handleFormSubmit}
					validationSchema={schema}
				>
					{({
						errors,
						handleBlur,
						handleChange,
						handleSubmit,
						touched,
						values
					}) => (
						<Form className="mb-4" noValidate onSubmit={handleSubmit}>
							<Row className="mb-4">
								<Col md={6} sm={12}>
									<FloatingLabel className="mb-4" controlId="email" label="Your new email address">
										<Form.Control
											// eslint-disable-next-line react/jsx-no-leaked-render
											isInvalid={touched.email && !!errors.email}
											// eslint-disable-next-line react/jsx-no-leaked-render
											isValid={touched.email && !errors.email}
											name="email"
											onBlur={handleBlur}
											onChange={handleChange}
											placeholder="Your new email address"
											required
											type="email"
											value={values.email}
										/>
										{errors.email ? <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback> : null}
									</FloatingLabel>
								</Col>
								<Col md={6} sm={12}>
									<PasswordWithShow
										// eslint-disable-next-line react/jsx-no-leaked-render
										isInvalid={touched.password && !!errors.password}
										// eslint-disable-next-line react/jsx-no-leaked-render
										isValid={touched.password && !errors.password}
										name="password"
										onBlur={handleBlur}
										onChange={handleChange}
										placeholder="Your password"
										required
										value={values.password}
									/>

									{errors.password ? (
										<Form.Control.Feedback
											className="d-block"
											type="invalid"
										>
											{errors.password}
										</Form.Control.Feedback>) : null}
								</Col>
							</Row>
							<Button disabled={loading} type="submit">
								{loading ? <Spinner animation="border" size="sm" /> : "Verify New Email Address"}
							</Button>
						</Form>
					)}
				</Formik>
			</LwcErrorBoundary>
		</div>
	);
};

export default ChangeEmailForm;
